import { StoreData } from "./store.data";

export type ClassificationModelVersion = 2;
export interface ClassificationStoreModel extends StoreData {
  /**  **Version Number** **/
  v: ClassificationModelVersion;

  /** Classification Name */
  n: string;

  /** Classification is Generate Default */
  gd: boolean; // when we import data and create accounts if there are no classification-renderer related to transaction
}

export const DefaultClassificationStoreModel: ClassificationStoreModel = {
  dc: "",
  dm: "",
  gd: false,
  id: "",
  n: "",
  v: 2,
  vid: "",
};
